import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'

export const useImageStore = defineStore('imageStore', () => {
  let syncableModel = useSyncableModel(useApiResource('images'), {
    paramKey: 'image'
  })

  function addImage(data) {
    const currentIndex = syncableModel.collection.value.findIndex((item) => {
      return item.type_id == data.type_id && (!item.entity_type || item.type == data.type)
    })

    if (currentIndex !== -1) syncableModel.collection.value.splice(currentIndex, 1)
    syncableModel.collection.value.push(data)
  }

  function findImage(uuid) {
    const obj = syncableModel.collection.value.find((item) => {
      return item.type_id == uuid
    })

    if (obj) return obj.uuid
    else return undefined
  }

  function findImages(uuid) {
    const objs = syncableModel.collection.value.filter((item) => {
      return item.type_id == uuid
    })

    if (objs) return objs.map((obj) => obj.uuid)
    else return undefined
  }

  function findImageWithType(uuid, type) {
    const obj = syncableModel.collection.value.find((item) => {
      return item.type_id == uuid && item.type == type
    })

    if (obj) return obj.uuid
    else return undefined
  }

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    addImage,
    findImage,
    findImages,
    findImageWithType,
    $reset
  }

}, {
  persist: true
})

